import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6cd1930d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd1930d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd1930d')) {
      api.createRecord('6cd1930d', component.options)
    } else {
      api.reload('6cd1930d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6cd1930d&scoped=true", function () {
      api.rerender('6cd1930d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/attach/index.vue"
export default component.exports